module.exports = __webpack_public_path__ + "img/sewage-pipe-active.d69a44b2.png";